import { useEffect } from 'react';
import './App.css';
import AboutMe from './components/AboutMeFolder/AboutMe';
import AboutMeHero from './components/AboutMeFolder/AboutMeHero';
import Company from './components/Company/Company';
import CompanyHero from './components/Company/CompanyHero';
import Hero from './components/HeroFolder/Hero';
import MiniAbout from './components/MiniAbout/MiniAbout';
import Nab from './components/NabFolder/Nab';
import Project from './components/ProjectFolder/Project';
import ProjectHero from './components/ProjectFolder/ProjectHero';
import Resume from './components/ResumeFolder/Resume';
import ResumeHero from './components/ResumeFolder/ResumeHero';
import Skill from './components/SkillFolder/Skill';
import SkillHero from './components/SkillFolder/SkillHero';

import { motion } from "framer-motion";

function App() {


  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
}, [ ])



  return (
    <>
      <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Hero />
      <Nab />
      <MiniAbout />
      <CompanyHero />
      <Company />
      <SkillHero />
      <Skill />
      <ProjectHero />
      <Project />
      <AboutMeHero />
      <AboutMe />
      <ResumeHero />
      <Resume />
      </motion.div>
    </>
  );
}

export default App;
